import { Box, HStack, IconButton } from '@chakra-ui/react';
import { useRef } from 'react';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';

type Props = {
  items: { key: string; label: string }[];
  selectedKey: string;
  onChange: (key: string) => void;
};

const SelectBox = ({ items, selectedKey, onChange }: Props) => {
  const itemRef = useRef(null);
  const keyExists = items.some((item) => item.key === selectedKey);
  const currentIndex = keyExists
    ? items.findIndex((item) => item.key === selectedKey)
    : 0;
  const selectedLabel = items.find((item) => item.key === selectedKey)?.label;

  // --------------------- methods ------------------------

  const handleChange = (newIndex: number) => {
    onChange(items[(newIndex + items.length) % items.length].key);
  };
  const selectNext = () => {
    handleChange(currentIndex + 1);
  };
  const selectPrevious = () => {
    handleChange(currentIndex - 1);
  };

  return (
    <HStack
      boxShadow="base"
      display="flex"
      p="5px"
      width="full"
      borderRadius="25px"
      overflow="hidden"
      justifyContent="space-between"
    >
      <Box>
        <IconButton
          aria-label="select previous panel"
          colorScheme="whiteAlpha"
          onClick={selectPrevious}
          icon={<MdKeyboardArrowLeft color="black" fontSize="150%" />}
        />
      </Box>

      <Box
        ref={itemRef}
        bg="white"
        // border="2px solid"
        fontWeight="bold"
        borderColor="primaryColor"
        className="noselect"
        color="primaryColor"
        p="15px 15px"
        borderRadius="25px"
        textAlign="center"
      >
        {selectedLabel}
      </Box>

      <Box>
        <IconButton
          aria-label="select next panel"
          colorScheme="whiteAlpha"
          onClick={selectNext}
          icon={<MdKeyboardArrowRight color="black" fontSize="150%" />}
        />
      </Box>
    </HStack>
  );
};
export default SelectBox;
